// Site Alias Management list Action Types
export const FETCH_SITE_ALIAS_MANAGEMENT_REQUEST = 'FETCH_SITE_ALIAS_MANAGEMENT_REQUEST';
export const FETCH_SITE_ALIAS_MANAGEMENT_SUCCESS = 'FETCH_SITE_ALIAS_MANAGEMENT_SUCCESS';
export const FETCH_SITE_ALIAS_MANAGEMENT_FAILURE = 'FETCH_SITE_ALIAS_MANAGEMENT_FAILURE';

// Loading all the sites for Site Alias Management
export const FETCH_GETALLSITES_REQUEST = 'FETCH_GETALLSITES_REQUEST';
export const FETCH_GETALLSITES_SUCCESS = 'FETCH_GETALLSITES_SUCCESS';   
export const FETCH_GETALLSITES_FAILURE = 'FETCH_GETALLSITES_FAILURE';

//Bulk Save in Site Alias Management 
export const BULK_SAVE_SITE_ALIAS_MANAGEMANT_REQUEST = 'BULK_SAVE_SITE_ALIAS_MANAGEMANT_REQUEST';
export const BULK_SAVE_SITE_ALIAS_MANAGEMANT_SUCCESS = 'BULK_SAVE_SITE_ALIAS_MANAGEMANT_SUCCESS';
export const BULK_SAVE_SITE_ALIAS_MANAGEMANT_FAILURE = 'BULK_SAVE_SITE_ALIAS_MANAGEMANT_FAILURE';

//Get Site Alias Management Details Action Types
export const SITEALIASMANAGEMENT_DETAILS_REQUEST = 'SITEALIASMANAGEMENT_DETAILS_REQUEST';
export const SITEALIASMANAGEMENT_DETAILS_SUCCESS = 'SITEALIASMANAGEMENT_DETAILS_SUCCESS';
export const SITEALIASMANAGEMENT_DETAILS_FAILURE = 'SITEALIASMANAGEMENT_DETAILS_FAILURE';

//Active/Deactive Site Alias Management Action Types
export const SITEALIASACTIVATEDEACTIVATE_REQUEST = 'SITEALIASACTIVATEDEACTIVATE_REQUEST';
export const SITEALIASACTIVATEDEACTIVATE_SUCCESS = 'SITEALIASACTIVATEDEACTIVATE_SUCCESS';
export const SITEALIASACTIVATEDEACTIVATE_FAILURE = 'SITEALIASACTIVATEDEACTIVATE_FAILURE';

// Export Site Alias Management Data
export const EXPORT_SITE_ALIAS_MANAGEMENT_REQUEST = 'EXPORT_SITE_ALIAS_MANAGEMENT_REQUEST';
export const EXPORT_SITE_ALIAS_MANAGEMENT_SUCCESS = 'EXPORT_SITE_ALIAS_MANAGEMENT_SUCCESS';
export const EXPORT_SITE_ALIAS_MANAGEMENT_FAILURE = 'EXPORT_SITE_ALIAS_MANAGEMENT_FAILURE';